module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Historian Christopher Duffy described the stereotype of a Russian officer: “For most of us, terms like ‘the Russian officer’ have connotations of dissolute young wastrels, who were freed of care and responsibility by the labor of thousands of serfs, who spent their evenings throwing vodka glasses against the wall, and who finally subsided into unconsciousness among a wreckage of a gilded furniture.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent75",
      "id": "theft75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" The reality was considerably different from this impression. Many Russian officers lived in poverty, without property or serfs. These officers were obligated to maintain clothing, equipment, and horses with meager salaries that barely covered living costs. The average pay during the Napoleonic Wars was as follows: ensigns received 125 rubles a year; sub-lieutenants, 142 rubles; lieutenants, 166 rubles; staff captains, 192 rubles; captains, 200 rubles; majors, 217 rubles; lieutenant colonels, 250 rubles; colonels, 334 rubles; major generals, 655; lieutenant generals, 794 rubles; and generals, 1,302 rubles. The artillery and cavalry officers received 10% higher salaries and the Guard officers earned 20% to 50% more than their regular infantry counterparts."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent76",
      "id": "theft76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" A complete officer uniform cost approximately 200 rubles, while dinner at a nice restaurant was about five rubles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Young officers from petty noble families often owned nothing but a bundle of clothes when they joined the regiment. Officer quarters held only objects essential for existence. According to Colonel Ilya Radozhitsky, “Beside his hand baggage, pipe with scanty tobacco and stacks of cards spread around on the floor, [the average] Russian officer had virtually nothing in his quarters.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent77",
      "id": "theft77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" Cossack Major General Adrian Denisov stated in his memoirs that his inadequate salary made him “short even of necessities.” Many times officers could not accumulate enough savings for equipment and food. General Arsenii A. Zakrevsky recalled that when he was stationed in Lithuania, he could afford nothing but eggs."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent78",
      "id": "theft78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" In some cases, officers followed the example of the rank and file and organized cartels (corporations) to help each other survive the campaign. There were also commanding officers who took care of their subordinates. Lieutenant General F. M. Numsen, who served as the Cavalry Inspector in Livonia, held weekly dinners for his officers to help them survive on their salaries."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent79",
      "id": "theft79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The records of service show that 77% of Russian officers in 1812 did not own property or serfs. The remaining 16% had serfs owned by their fathers, who supported them, and less than four percent had property owned by other members of their families. Almost all foreign officers in the Russian army held no assets in Russia and depended on their salaries to survive. The same condition applied to 88.6% of the Polish officers and 83.1% of officers from the Baltic provinces. Virtually no junior officers, including non-commissioned officers, owned estates or serfs."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent80",
      "id": "theft80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The data on army branches also shows the difference in financial and property status between the officers. Naturally, the Guard units had the most affluent officers: 38% of them owned serfs and property. The cavalry officers were the least affluent (21.95%) followed by infantry’s 20.3% and artillery’s 15.4%. Despite its imposing name, the officers in the Quartermaster Section of the Imperial Retinue were the most deprived; only 9.8% of them owned any property or serfs.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6344a890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof18.vue
// module id = 147
// module chunks = 0